module.exports = __webpack_public_path__ + "static/media/lego-batman.8cfec538.jpg";